<div
      class="text-sm font-medium text-text-secondary border-b border-border relative overflow-x-auto scrollbar-none w-full bg-surface-elevated/50 backdrop-blur-sm rounded-t-2xl">
      <ul class="flex justify-center relative min-w-max px-4">

            <!-- Active underline animated -->
            <span class="absolute bottom-0 h-0.5 bg-primary rounded-full transition-all duration-300 ease-out shadow-[0_-2px_10px_rgba(228,87,5,0.5)] z-20"
                  [style.width.px]="activeTabWidth" [style.left.px]="activeTabLeft"></span>

            <li *ngFor="let tab of tabs; let i = index" #tabRef class="relative">
                  <button (click)="onTabClick(tab.id)" type="button"
                        class="tab-btn relative inline-flex items-center justify-center px-6 py-4.5 text-xs font-bold uppercase tracking-wider transition-all duration-300 whitespace-nowrap focus:outline-none hover:text-text-primary"
                        [class.text-primary]="isActiveTab(tab.id)"
                        [class.text-text-secondary]="!isActiveTab(tab.id)">

                        <!-- نص التبويب -->
                        <span class="relative z-10 transition-transform duration-200"
                              [class.scale-105]="isActiveTab(tab.id)">
                              {{ tab.title | translate }}
                        </span>

                        <!-- تأثير خلفية خفيف جداً عند الـ Hover -->
                        <span
                              class="absolute inset-x-2 top-2 bottom-2 rounded-xl bg-surface-hover opacity-0 hover:opacity-100 transition-opacity duration-200 -z-0"></span>
                  </button>
            </li>

      </ul>
</div>